import { GiftStatus } from 'src/admin-entity/enum/order/gift/gift-status.type';
import { OrderItemProductStatusSearch } from 'src/admin-entity/enum/order/order-item-product-status-search.type';
import { PaymentMethodType } from 'src/admin-entity/enum/payment/payment-method-type.enum';
import { PaymentStatus } from 'src/admin-entity/enum/payment/payment-status.enum';
import { Log } from 'src/admin-entity/interface/log/logs.interface';
import { GiftOrderItem } from 'src/admin-entity/interface/order/gift/gift-order-item.interface';
import { OrderHistory } from 'src/admin-entity/interface/order/order-history.interface';

export interface GiftInitType {
    searchState: {
        page: number;
        take: number;
        selectedTopic: { id: number; name: string; value: string };
        searchText: string;
        productName: string;
        name: string; // 주문자
        phone: string;
        beginDate: string;
        endDate: string;
        giftStatus: GiftStatus[];
        orderItemProductStatus: OrderItemProductStatusSearch[];
    };
    list: GiftOrderItem[];
    page: {
        count: number;
    };
    giftOrderItemDetail: GiftOrderItem;
    giftOrderPriceHistory: OrderHistory[];
    giftOrderHistory: Log[];
    isMemoOpen: boolean;
    isOpenWithdrawModal: boolean;
    selectedMemoContents: string;
    selectedGiftId: number;
    selectedGiftGroupId: number;
}

export const initialState: GiftInitType = {
    searchState: {
        page: 0,
        take: 25,
        selectedTopic: { id: 1, name: '선택안함', value: '' },
        searchText: '',
        productName: '',
        name: '', // 주문자
        phone: '',
        beginDate: new Date(new Date().setDate(new Date().getDate() - 7)).toString(),
        endDate: new Date().toString(),
        giftStatus: ['addressEntered', 'canceled', 'expire', 'unused'],
        orderItemProductStatus: ['paid', 'withdraw_complete', 'delivery_waiting', 'delivering', 'delivery_end'],
    },
    list: [],
    page: {
        count: 0,
    },
    giftOrderItemDetail: {
        appUser: {
            count: {
                favorites: 0,
                shoppingCarts: 0,
            },
            id: 0,
            name: '',
            phone: '',
            email: '',
        } as any,
        createDate: new Date().toString(),
        giftGroupStatus: PaymentStatus.PAID,
        giftToCount: 0,
        giftTos: [],
        giftTotalPrice: 0,
        giftTotalProductsPrice: 0,
        giftTotalShippingFee: 0,
        id: 0,
        message: '',
        orderItemProducts: [],
        paymentMethodType: PaymentMethodType.BANK_CARD,
        pgType: 'tossPayments',
        uuid: '',
        memo: '',
        receiptUrl: '',
        adminMemo: '',
        canAllWithdraw: true,
    },
    giftOrderPriceHistory: [],
    giftOrderHistory: [],
    isMemoOpen: false,
    isOpenWithdrawModal: false,
    selectedMemoContents: '',
    selectedGiftId: 0,
    selectedGiftGroupId: 0,
};
